<template>
  <div>
    <div class="row">
      <div class="col s4">
        <div class="input-field">
          <select v-model="selectedOrganisationId" class="browser-default" @change="proces()"  v-if="!showAddUser">
            <option v-for="organisation in organisations" :value="organisation.id" :key="organisation.id">
              {{ organisation.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col s3 right" style="padding-top: 15px;">
        <button
                type="button"
                class="waves-effect waves-light btn blue"
                @click="showAddUser = true"
                v-if="!showAddUser">
          {{ $t('management.add') }}
        </button>
      </div>
    </div>
    <user-edit v-if="showAddUser" :locales="this.locales" :model="selectedUser" :cancelFn="navigateToList2" :organisations="this.organisations"/>
    <div class="col s12">
      <div class="content-box z-depth-1 white">
        <div class="row">
          <table class="striped" v-if="!showAddUser">
            <thead>
              <tr>
                <th v-for="(value, index) in table.headers" v-bind:key="index" @click="sortTableData(value.displayName)" class="clickable">
                    {{$t( value.displayName)}}
                  <i v-show="value.displayName === table.sort.by && table.sort.order === 'desc'" class="material-icons tiny">arrow_drop_up</i>
                  <i v-show="value.displayName === table.sort.by && table.sort.order === 'asc'" class="material-icons tiny">arrow_drop_down</i>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="clickable" v-for="(measurement, index) in selectedData" v-bind:key="index" v-on:click="edit(index + ((paging.itemsPerPage)*(paging.selectedPage - 1)))">
                <!--<td style="padding:0px !important;" v-for="(name, index) in (measurement)" v-bind:key="index"> {{ name }}</td>-->
                <!-- manual  :-(  do not want to show all colums -->
                <td style="padding:0px !important;"> {{ measurement.managementusername }} </td>
                <td style="padding:0px !important;"> {{ measurement.managementorganisationname }} </td>
                <td style="padding:0px !important;"> {{ formattedDT(measurement.managementlastlogin) }} </td>
              </tr>
            </tbody>
          </table>
          <div class="row"  v-if="!showAddUser">
            <ul class="pagination center" >
              <li :class="{'disabled': paging.selectedPage === 1}"><a class="clickable" @click="paging.selectedPage > 1 && paging.selectedPage--"><i class="material-icons">chevron_left</i></a></li>
              <li v-for="(page, index) in paging.totalPages" :class="{active: index + 1 === paging.selectedPage}" @click="paging.selectedPage = index + 1" v-bind:key="index" class="waves-effect"><a class="clickable">{{page}}</a></li>
              <li :class="{'disabled': paging.selectedPage === paging.totalPages}" class="waves-effect"><a class="clickable" @click="paging.selectedPage < paging.totalPages && paging.selectedPage++"><i class="material-icons">chevron_right</i></a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from '../../../services/api/LanguageService'
import usersApi from '../../../services/api/UsersApi'
import organisationsApi from '@/services/api/OrganisationsApi'
import Router from '../../../router'
import _ from 'lodash'
import UserEdit from './UserEdit'

export default {
  name: 'UserList',
  props: {},
  data () {
    return {
      componentKey: 0,
      locales: [],
      showAddUser: false,
      selectedOrganisationId: null,
      selectedUser: {},
      rawdata: null,
      paging: {
        itemsPerPage: 25,
        totalPages: 0,
        selectedPage: 1
      },
      table: {
        headers: [
          { displayName: 'managementusername' },
          { displayName: 'managementorganisationname' },
          { displayName: 'managementlastlogin' }
        ],
        data: [],
        sort: {
          by: 'managementorganisationname',
          order: 'asc'
        }
      },
      organisations: []
    }
  },
  components: {
    UserEdit
  },
  computed: {
    selectedData: function () {
      return this.table.data.slice((this.paging.selectedPage - 1) * this.paging.itemsPerPage, this.paging.selectedPage * this.paging.itemsPerPage)
    }
  },
  watch: {},
  beforeMount () {
    LanguageService.getLanguages()
      .then(response => {
        response.data.forEach(element => {
          this.locales.push(element.Translation)
        })
      })
      .catch(e => {
        console.log(e)
      })
  },
  created: function () {
    this.getAllUsers()
    this.getAllOrganisations()
  },
  methods: {
    async getAllUsers () {
      this.rawdata = null
      await usersApi.getUsers()
        .then(result => {
          this.rawdata = result
          this.proces()
        })
    },
    async getAllOrganisations () {
      this.organisations = []
      this.organisations.push({
        id: null,
        name: this.$t('management.allUsers')
      })
      let organisationResult = await organisationsApi.getOrganisations()
      try {
        this.organisations = this.organisations.concat(organisationResult.data.sort((a, b) => (a.name > b.name ? 1 : -1)))
      } catch (e) {
        console.log(e)
      }
    },
    formattedDT: function (val) {
      if (val) {
        return val.toString().substring(0, 10)
      } else {
        return ''
      }
    },
    proces () {
      this.table.data = []
      this.rawdata.data.forEach(r => {
        if (this.selectedOrganisationId === null || this.selectedOrganisationId === r.Organisation.OrganisationId) {
          var un = ''.concat(r.FirstName ? r.FirstName : '', ' ', r.MiddleName ? r.MiddleName.concat(' ') : '', r.LastName ? r.LastName : '')
          this.table.data.push({
            'managementusername': un,
            'managementorganisationname': r.Organisation.OrganisationName,
            'organisationId': r.Organisation.OrganisationId,
            'userId': r.UserV61id,
            'role': r.SystemRoleId,
            'userstatus': r.UserStatus,
            'managementlastlogin': r.LastLoginDatetime
          })
        }
        this.paging.totalPages = Math.ceil(this.table.data.length / this.paging.itemsPerPage)
      })
    },
    navigateToList () {
      this.showAddUser = true
      this.selectedUser = {}
      this.selectedOrganisationId = null
      this.getAllUsers()
      Router.push('/users')
    },
    navigateToList2 () {
      this.getAllUsers()
      Router.go(0)
    },
    getUser (id) {
      usersApi.getUser(id)
        .then(result => {
          const user = result.data
          this.selectedUser = user
        })
    },
    sortTableData (columnToSortBy) {
      if (columnToSortBy === this.table.sort.by) {
        this.table.data = _.orderBy(this.table.data, columnToSortBy, [(this.table.sort.order === 'asc' ? this.table.sort.order = 'desc' : this.table.sort.order = 'asc')])
      } else {
        this.table.data = _.orderBy(this.table.data, columnToSortBy, ['asc'])
      }
      this.table.sort.by = columnToSortBy
    },
    showAdd () {
      this.showAddUser = true
    },
    edit (id) {
      var uId = this.table.data[id].userId
      Router.push('/users/' + uId)
    },
    async editUser () {
      await usersApi.editUser(this.selectedUser)
      this.getAllUsers()
      this.hideEditUser()
    }
  }
}
</script>

<style scoped>
  .title {
    font-size: x-large;
    font-weight: bold;
    padding: 1rem
  }

  table {
    margin: -1rem 1rem;
    width: 95%;
  }

  .icons>*{
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/usermanagement/users/UserList.vue